import styled from '@emotion/styled';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQuery';
import { HEADER_PADDING_DESKTOP, HEADER_PADDING_MOBILE } from '../../CardListing.styles';

export const CardListingHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.S16};
  padding: ${SPACING.S16} ${HEADER_PADDING_MOBILE} ${SPACING.S16};

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    padding: ${SPACING.S16} ${HEADER_PADDING_DESKTOP} ${SPACING.S16};
  }

  .card-listing-filter-container {
    margin: 0 -${HEADER_PADDING_MOBILE};

    ${MEDIA_QUERY.EXCLUDE_MOBILE} {
      margin: 0 -${HEADER_PADDING_DESKTOP};
    }
  }

  .card-listing-filter {
    padding-left: ${HEADER_PADDING_MOBILE};
    padding-right: ${HEADER_PADDING_MOBILE};

    ${MEDIA_QUERY.EXCLUDE_MOBILE} {
      padding-left: ${HEADER_PADDING_DESKTOP};
      padding-right: ${HEADER_PADDING_DESKTOP};
    }
  }
`;
